import React from 'react'

import ErrorModal from './error-modal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

function SaveErrorModal ({ isOpen, handleClose }: Props) {
  return (
    <ErrorModal
      isOpen={isOpen}
      title="Save failed"
      description="Your changes couldn't be saved. Please try again."
      handleClose={handleClose}
    />
  )
}

export default SaveErrorModal
